/* eslint-disable no-bitwise */
export enum UserPrivilege3 {
  MailListPoker = 1 << 0,
  MailListCasino = 1 << 1,
  MailListSports = 1 << 2,
  SportLiveAlert = 1 << 30,
  WithdrawalCancellation = 1 << 13,
  NoWithdraw = 1 << 7,
  NoSportsPlay = 1 << 4
}
